/* jshint esnext: true */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['textarea'];

  clear() {
    this.textareaTarget.value = '';
    this.textareaTarget.focus();
    // Notify other controllers (e.g., payroll-table#markDirty) about the change
    this.textareaTarget.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
